//#region src/tax_rounding_mode.ts
var TaxRoundingMode = /* @__PURE__ */ function(TaxRoundingMode) {
	TaxRoundingMode["Round"] = "round";
	TaxRoundingMode["Ceil"] = "ceil";
	TaxRoundingMode["Floor"] = "floor";
	return TaxRoundingMode;
}(TaxRoundingMode || {});
//#endregion
export { TaxRoundingMode };

//# sourceMappingURL=tax_rounding_mode.js.map